import { render, staticRenderFns } from "./RewardsTitle.vue?vue&type=template&id=67b8e0be&scoped=true&"
import script from "./RewardsTitle.vue?vue&type=script&lang=js&"
export * from "./RewardsTitle.vue?vue&type=script&lang=js&"
import style0 from "./RewardsTitle.vue?vue&type=style&index=0&id=67b8e0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b8e0be",
  null
  
)

export default component.exports